import TransactionModal from "./transactionModal.js";
import { $_GET } from "../globalFunctions.js";

export default class SplitModal extends TransactionModal {
  constructor(companyId, reverse = false) {
    super("split-modal", companyId);
    this.$splitSummary = document.getElementById("split-summary");
    this.$title = document.getElementById("split-modal-title");
    this.$split = this.$form.querySelector('[name="amount"]');
    this.$date = this.$form.querySelector('[name="date"]');
    this.$reverse = reverse;

    this.formFields = [
      {
        name: "id",
        varType: "int",
      },
      {
        name: "amount",
        varType: "int",
        trigger: "input",
        required: true,
      },
      {
        name: "date",
        varType: "string",
        required: true,
      },
      {
        name: "documents",
        varType: "simple-array",
        type: "int",
      },
      {
        name: "notes",
      },
    ];

    this.setupForm();

    Promise.all([
      this.documentsPromise,
      this.getLatestValuation(),
      this.getSharesCount(),
    ]).then(() => {
      this.$form.querySelector("[data-current-valuation]").innerText =
        peque.formatNumber(this.currentValuation * this.currentSharesCount);

      if (this.prefillData == null) {
        this.$split.value = 10;
        this.updateShownSplit(this.$split.value);
      }

      this.whenReady();
    });
  }

  setReverse(reverse) {
    this.$reverse = reverse;
  }

  setupForm() {
    this.$form.querySelector('[name="date"]').valueAsDate = new Date();

    this.$split.addEventListener("input", () => {
      this.updateShownSplit(this.$split.value);
    });

    this.$date.addEventListener("change", async () => {
      await Promise.all([this.getLatestValuation(), this.getSharesCount()]);
      this.updateShownSplit(this.$split.value);
    });

    if (this.$reverse) {
        this.$title.innerText = trans("reverse_split");
    }
  }

  getLatestValuation() {
    return new Promise((resolve, reject) => {
      peque
        .api(
          "valuations/latest",
          {
            company: this.companyId,
            simulation: $_GET("simulation"),
            date: this.$date.value,
          },
          "get"
        )
        .then((response) => {
          this.currentValuation = response.result
            ? response.result.private.price
            : 0;

          this.$form.querySelector("[data-current-pps]").innerText =
            this.currentValuation;
          resolve();
        });
    });
  }

  getSharesCount() {
    return new Promise((resolve, reject) => {
      peque
        .api(
          "shares/count",
          {
            company: this.companyId,
            simulation: $_GET("simulation"),
            date: this.$date.value,
          },
          "get"
        )
        .then((response) => {
          this.currentSharesCount = response.result ? response.result.total : 0;

          this.$form.querySelector("[data-current-shares-count]").innerText =
            peque.formatNumber(this.currentSharesCount);
          resolve();
        });
    });
  }

  updateShownSplit(amount) {
    amount = parseInt(amount);

    if (amount < 1 || isNaN(amount)) {
      this.$splitSummary.classList.add("d-none");
      return;
    }

    this.$splitSummary.classList.remove("d-none");

    this.$form.querySelectorAll("[data-split-amount]").forEach((el) => {
      el.innerText = amount;
    });

    if (this.$reverse) {
        this.$form.querySelector("[data-new-shares-count]").innerText =
            peque.formatNumber(this.currentSharesCount / amount);
        this.$form.querySelector("[data-new-pps]").innerText = peque.formatNumber(
            this.currentValuation * amount
        );
    } else {
      this.$form.querySelector("[data-new-shares-count]").innerText =
          peque.formatNumber(this.currentSharesCount * amount);
      this.$form.querySelector("[data-new-pps]").innerText = peque.formatNumber(
          this.currentValuation / amount
      );
    }
  }

  validateAndSendForm() {
    this.enableSubmitButton(false);

    this.getFields(this.formFields)
      .then((data) => {
        data.company = this.companyId;
        data.simulation =
          typeof window.pequeData.simulation === "undefined"
            ? $_GET("simulation")
            : window.pequeData.simulation;
        data.type = this.$reverse ? peque.TRANSACTION_TYPE_REVERSE_STOCK_SPLIT : peque.TRANSACTION_TYPE_SPLIT;

        peque
          .api("transactions", JSON.stringify(data), "post")
          .then((response) => {
            this.mutateReactTransactions();
          })
          .catch((error) => {
            this.enableSubmitButton(true);

            if (error.error === peque.ERROR_DUPLICATED_ENTRY) {
              peque.navigation.showError(error.result);
            }
          });
      })
      .catch((error) => {
        this.enableSubmitButton(true);

        if (typeof error.el === "undefined") {
          throw error;
        }
        this.showErrorOnField(error.message, error.el);
      });
  }
}
